<!-- Workspace Overview — container -->
<section class="flex flex-col gap-4 w-full min-w-0">
    <!-- Header row: title + toggles + export -->
    <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <h4 class="font-bold text-md">Workspace overview</h4>

        <div class="flex flex-wrap items-center gap-2">
            <!-- User / Admin segmented toggle (only visible when user has admin RBAC) -->
            <app-select-button *ngIf="state.canSwitchView" aria-label="View scope" [options]="state.viewModeOptions"
                [size]="'small'" [ngModel]="state.viewMode()" (selectionChange)="state.setViewMode($event)">
            </app-select-button>

            <!-- Week / Month / Quarter / Custom segmented toggle -->
            <app-select-button aria-label="Period filter" [options]="state.periodOptions" [size]="'small'"
                [ngModel]="state.period()" (selectionChange)="state.setPeriod($event)">
            </app-select-button>

            <!-- Custom date range picker (only when Custom is selected) -->
            <app-datepicker *ngIf="state.period() === PeriodFilter.Custom" [(value)]="customDates"
                (valueChange)="state.onCustomDatesChange($event)" [config]="{
                    selectionMode: 'range',
                    showIcon: true,
                    placeholder: 'Select range',
                    dateFormat: 'dd M yy',
                    appendTo: 'body',
                    maxDate: today
                }" class="min-w-[16rem]">
            </app-datepicker>

            <!-- Export button (stub) -->
            <!-- <app-button variant="outlined" severity="contrast" size="sm" icon="pi pi-download" label="Export"
                (clicked)="onExport()" pTooltip="Export coming soon" tooltipPosition="top">
            </app-button> -->
        </div>
    </div>

    <!-- Row 1: Time Reclaimed (3/5) + Bob Assisted Hours (2/5) -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <app-time-reclaimed-widget class="min-w-0"></app-time-reclaimed-widget>
        <app-bob-assisted-hours-widget class="min-w-0"></app-bob-assisted-hours-widget>
    </div>

    <!-- Row 2: Documents Enhanced (full width) -->
    <app-documents-enhanced-widget class="w-full min-w-0"></app-documents-enhanced-widget>

    <!-- Row 3: Ask Bob Standalone + Untapped Potential -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <app-ask-bob-standalone-widget class="min-w-0"></app-ask-bob-standalone-widget>
        <app-untapped-potential-widget class="min-w-0 h-full" (featureClick)="onUntappedFeatureClick($event)">
        </app-untapped-potential-widget>
    </div>

    <!-- Row 4: Feedback & Quality (admin-only, full width) -->
    <!-- <app-feedback-quality-widget *ngIf="state.showFeedbackQuality()" class="w-full min-w-0">
    </app-feedback-quality-widget> -->

    <!-- Row 5: Projects + Document Counts -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <app-projects-widget class="min-w-0"></app-projects-widget>
        <app-document-counts-widget class="min-w-0"></app-document-counts-widget>
    </div>
</section>